import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface PhoneVerificationState {
	dismissedReplacements: string[];
}

const initialState: PhoneVerificationState = {
	dismissedReplacements: []
};

export const phoneReplacementDismissalKey = (
	scope: string | undefined,
	verifiedE164: string | null,
	pendingE164: string | null
): string => JSON.stringify([scope ?? "", verifiedE164, pendingE164]);

const phoneVerificationSlice = createSlice({
	initialState,
	name: "phoneVerification",
	reducers: {
		clearPhoneReplacementDismissal: (state, action: PayloadAction<string>) => {
			state.dismissedReplacements = state.dismissedReplacements.filter((key) => key !== action.payload);
		},
		dismissPhoneReplacement: (state, action: PayloadAction<string>) => {
			if (!state.dismissedReplacements.includes(action.payload)) {
				state.dismissedReplacements.push(action.payload);
			}
		}
	}
});

export const { clearPhoneReplacementDismissal, dismissPhoneReplacement } = phoneVerificationSlice.actions;

export default phoneVerificationSlice.reducer;
